'use client';

/**
 * Landing.tsx — forside (rotdomenet `/`)
 *
 * Komponerer den offentlige forsiden: header, hero, plattform-påstand,
 * modulfliser, funksjonsrader, plattformfunksjoner, avsluttende CTA og footer.
 * Ingen UI Shell (ROUTES_WITHOUT_SHELL i ClientUiShell.tsx); siden har egne
 * landmarks (header / main / footer).
 *
 * Innhold: statisk, norsk + engelsk, se landing-content.ts. Språket styres av
 * useLocale (lagres i localStorage, standard følger nettleseren).
 */

import Capabilities from '@/components/landing/Capabilities';
import ClosingCta from '@/components/landing/ClosingCta';
import FeatureRows from '@/components/landing/FeatureRows';
import LandingFooter from '@/components/landing/LandingFooter';
import LandingHeader from '@/components/landing/LandingHeader';
import LeadSpace from '@/components/landing/LeadSpace';
import ModuleGrid from '@/components/landing/ModuleGrid';
import PlatformStatement from '@/components/landing/PlatformStatement';
import PromoBanner from '@/components/webhotell/PromoBanner';
import { useLocale } from '@/hooks/useLocale';
import { LANDING_CONTENT } from './landing-content';
import styles from './landing.module.css';

export default function Landing() {
  const { locale, setLocale } = useLocale();
  const content = LANDING_CONTENT[locale];

  return (
    <div className={styles.page}>
      <LandingHeader ui={content.ui} nav={content.nav} locale={locale} onLocaleChange={setLocale} />
      <main id="innhold" className={styles.main}>
        <LeadSpace hero={content.hero} />
        <PlatformStatement platform={content.platform} />
        <ModuleGrid modules={content.modules} />
        <FeatureRows features={content.features} />
        <Capabilities capabilities={content.capabilities} />
        <PromoBanner promo={content.webhotellPromo} />
        <ClosingCta cta={content.cta} />
      </main>
      <LandingFooter
        tagline={content.footer.tagline}
        legal={content.footer.legal}
        columns={[
          { heading: content.footer.platformLabel, links: content.nav },
          {
            heading: content.footer.modulesLabel,
            links: content.modules.items.map((m) => ({ label: m.name, href: m.href })),
          },
        ]}
      />
    </div>
  );
}
